import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './index.css'
import '@fontsource-variable/inter'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/700.css'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
